module.exports = __webpack_public_path__ + "static/media/new.a9593d02.svg";